module.exports = __webpack_public_path__ + "static/media/sample-club.19f5835e.png";